import Link from "next/link";
import { useTranslation } from "next-i18next";
import { GamificationUserCard } from "@filadd/phi-plus-layout";
import { useCourseSlug } from "hooks/course";
import { useLayoutTrinket } from "hooks/layout";
import { TrinketNames } from "types/layout";

export const GamificationTrinket = () => {
  const { t } = useTranslation("common");

  const courseSlug = useCourseSlug();
  const { data: trinket } = useLayoutTrinket({
    trinketName: TrinketNames.GAMIFICATION,
    courseSlug,
  });

  if (!trinket || trinket.name !== TrinketNames.GAMIFICATION) {
    return null;
  }

  const weekText = t("week", { count: trinket?.data.streak });

  return (
    <Link
      href={{
        pathname: "/courses/[courseSlug]/content/games",
        query: { courseSlug },
      }}
    >
      <GamificationUserCard
        {...trinket.data}
        levelText={t("level")}
        xpText={t("experience")}
        streakText={weekText}
      />
    </Link>
  );
};
